import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    fetchAllOfferMessages,
    selectFetchingAllOfferMessages,
    selectAllOfferMessages
} from '../../redux/actions/offers';
import { useDispatch, useSelector } from '../../redux/hooks';
import { Header, Table } from '../CommonComponents';
import { Container, Paper } from '../StyledComponents';

const columns = [{
    name: 'Uppdrag',
    key: 'orderId',
    canSearch: true
}, {
    name: 'Uppdragsgivare',
    key: 'orderTenantName',
    canSearch: true
}, {
    name: 'Anbudsgivare',
    key: 'offerTenantName',
    canSearch: true
}, {
    name: 'Företag',
    key: 'tenantName',
    canSearch: true
}, {
    name: 'Användare',
    key: 'userName',
    canSearch: true
}, {
    name: 'Meddelande',
    key: 'message',
    canSearch: true
}, {
    name: 'Skapades',
    key: 'createdAt',
    type: 'datetime' as 'datetime',
    canFilter: true
}];

export default function OfferMessages() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const offerMessages = useSelector(selectAllOfferMessages());
    const isFetching = useSelector(selectFetchingAllOfferMessages());

    React.useEffect(() => {
        dispatch(fetchAllOfferMessages());
    }, [dispatch]);

    const onRowClick = React.useCallback((offerMessage: { orderId: number }) => {
        navigate(`/orders/${offerMessage.orderId}`);
    }, [navigate]);

    return (
        <Container>
            <Header title="Meddelanden" />

            <Paper padding={0}>
                <Table
                    name="offerMessages"
                    columns={columns}
                    data={offerMessages}
                    onRowClick={onRowClick}
                    emptyText={isFetching ? 'Hämtar meddelanden...' : 'Det finns inga meddelanden.'}
                    showPagination
                    defaultOrderBy="createdAt"
                    defaultOrderDirection="asc"
                />
            </Paper>
        </Container>
    );
}
